import { Parser } from 'formulex';

/**
 * Возвращает массив из indexов полей с формулой, содержащих поле по fieldIndex
 */
export const getFieldsFormulasDepending = (catalog, fieldIndex) => {
  const field = catalog.getIn(['fields', fieldIndex]);
  const fieldId = field.get('id');
  const fieldNewId = field.get('newId');

  const nonImutFields = catalog.get('fields').toJS();

  const dependencies = [];

  nonImutFields.forEach((f, idx) => {
    const formula = f.formulaConfig?.formula;
    if (!formula) return;

    try {
      const parser = new Parser(formula, nonImutFields);
      const usedVariables = parser.getVariables();

      if (usedVariables.includes(fieldNewId || fieldId)) {
        dependencies.push(idx);
      }
    } catch {}
  }, []);

  return dependencies;
};
